module.exports = __webpack_public_path__ + "img/5.01d288fc.png";